import { useAuthStore } from '../../stores/auth'

const hasAnyPermission = (permissions) => {
    const authStore = useAuthStore();
    return permissions.some(permission => authStore.hasPermission(permission));
};

export const hrRoutes = [
    {
        path: 'profile',
        name: 'profile',
        component: () => import('../../views/UserProfile.vue'),
        meta: {
            requiresAuth: true,
            title: 'My Profile'
        }
    },
    {
        path: 'employees',
        name: 'employees',
        component: () => import('../../views/Employees.vue'),
        meta: {
            requiresAuth: true,
            permissions: ['employees.view', 'employees.manage'],
            title: 'Employees'
        },
        beforeEnter: (to, from, next) => {
            if (hasAnyPermission(to.meta.permissions)) {
                next();
            } else {
                next({ name: 'forbidden' });
            }
        }
    },
    {
        path: 'payslips',
        name: 'payslips',
        component: () => import('../../views/Payslips.vue'),
        meta: {
            requiresAuth: true,
            permissions: ['PAYSLIPS_VIEW', 'PAYSLIPS_MANAGE'],
            title: 'Payslips'
        },
        beforeEnter: (to, from, next) => {
            if (hasAnyPermission(to.meta.permissions)) {
                next();
            } else {
                next({ name: 'forbidden' });
            }
        }
    }
];
